define((require) => {
    "use strict";

    const $                     = require("jquery");
    const {isBoolean}           = require("underscore");
    const Icons                 = require("shared/ui/assets/Icons");
    const ImageDropManager      = require("services/ImageDropManager");
    const {Renderer, Behavior}  = require("marionette");
    const Permissions           = require("shared/security/Permissions");
    const template              = require("ui/behaviors/DropAreaHotspot.tpl");

    /**
     * A behavior that represents a "drop area" for uploading specific files.
     *
     * If no `dropManager` is specified, the `ImageDropManager` is used.
     *
     * @class DropAreaHotspot
     */
    return Behavior.extend("DropAreaHotspot", {

        defaults: {
            dropManager: ImageDropManager,
            message: "<strong>Drop image(s)</strong> here to add directly<br>to Image Library",
            iconSize: "small",
            hideOverlayDuringLoad: false,
            uploadEnabled: true
        },

        _$overlay: null,

        coverArea: null,

        events: {
            "change .upload": "_uploadChangeHandler"
        },

        _uploadChangeHandler(event) {
            const uploadDescriptor = this.options.dropManager.upload({files: event.target.files});

            if (uploadDescriptor.models.length > 0) {
                this.view.triggerMethod("upload", uploadDescriptor);
            }
            // reset input in order the `change` event to be triggered even
            // if a users selects the same file in the file upload dialog
            event.target.form.reset();
        },

        onShow() {
            this._showDropTarget = this.view.options.showDropTarget !== false && Permissions.Privileges.CREATE.can();
            this._hideOverlayDuringLoad = isBoolean(this.view.options.hideOverlayDuringLoad) ?
                this.view.options.hideOverlayDuringLoad : this.options.hideOverlayDuringLoad;

            if (this._showDropTarget) {
                this.addOverlay();
                this.addIcon();

                const body = $(document.body);

                this.$el.draghover(() => {
                    this.$el.addClass("draghover");
                }, () => {
                    this.$el.removeClass("draghover");
                });

                body.draghover(() => {
                    if (!body.hasClass("internal-drag")) {
                        body.addClass("draghover");
                    }
                }, () => {
                    body.removeClass("draghover");
                });

                if (this.options.uploadEnabled) {
                    const {dropManager} = this.options;

                    dropManager.addElement(this.$el);

                    dropManager.on("upload", (uploadDescriptor) => {
                        this.view.triggerMethod("upload", uploadDescriptor);
                    });

                    dropManager.on("file:uploaded", (model) => {
                        this.view.triggerMethod("file:uploaded", model);
                    });
                }
            }
        },

        onClose() {
            if (this._showDropTarget && this.options.uploadEnabled) {
                const {dropManager} = this.options;

                dropManager.removeElement(this.$el);
                dropManager.off(null, null, this);
            }
        },

        /**
         * Invoked when the associated view is in a "loading" state, e.g. lazy loading content.
         *
         * Hides the overlay during load.
         */
        onLoadStart() {
            if (this._hideOverlayDuringLoad && this._$overlay) {
                this._$overlay.hide();
            }
        },

        /**
         * Invoked when the associated view is no longer in a "loading" state, e.g. lazy loading content.
         *
         * Shows the overlay during load.
         */
        onLoadEnd() {
            if (this._hideOverlayDuringLoad && this._$overlay) {
                this._$overlay.show();
            }
        },

        // Add the hot spot overlay, this will be shown to indicate the area dropable whenever something is dragged in
        addOverlay() {
            this._$overlay = $(Renderer.render(template));
            this._$overlay.addClass(`drop-target-${this.options.iconSize}`);
            this._$overlay.find(".drop-target-message").html(this.options.message);

            this.coverArea = this.$(this.options.dropAreaSelector);
            this.coverArea.prepend(this._$overlay);
        },

        addIcon() {
            const icon = this.options.iconSize === "large" ? Icons.DROP_TARGET_LARGE : Icons.DROP_TARGET_SMALL;
            this._$overlay.find(".icon").append(icon.createElement().addClass("drop-target-icon"));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/behaviors/DropAreaHotspot.js